import Icon from 'veui/components/Icon'

Icon.register({
  pin: {
    paths: [
      {
        d: 'M726.63 233.37l-192-192A32 32 0 00491 39.9L240.17 259A223.81 223.81 0 0040.9 320.8a32 32 0 000 45.26l158.32 158.31L72.86 649.88A32 32 0 10118 695.29l126.47-125.66L402.94 728.1a32 32 0 0045.26 0A223.84 223.84 0 00510 528.75L728.19 277a32 32 0 00-1.56-43.63zM451.1 499a32 32 0 00-6.73 29.21 161 161 0 01.33 81.65 159 159 0 01-21.41 48L111.06 345.71a159 159 0 0148-21.41 161 161 0 0181.65.33 32 32 0 0029.31-6.81l240.46-210 149.83 149.74z'
      }
    ],
    width: '768',
    height: '768'
  }
})
